import React from 'react';
import { cn } from '@/lib/utils';

function Table({ columns, data, emptyMessage = 'No data available' }) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-white/8">
        <thead>
          <tr className="bg-white/[0.03]">
            {columns.map((column) => (
              <th
                key={column.key}
                className={cn("px-2.5 sm:px-4 py-2 sm:py-2.5 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider", column.cellClassName)}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/6">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-white/[0.04] transition-colors">
              {columns.map((column) => (
                <td key={column.key} className={cn("px-2.5 sm:px-4 py-2.5 sm:py-3 whitespace-nowrap text-sm text-muted-foreground", column.cellClassName)}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
